import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
    FLUSH,
    PAUSE,
    PERSIST,
    persistReducer,
    persistStore,
    PURGE,
    REGISTER,
    REHYDRATE,
} from 'redux-persist';
import userReducer from '../slices/userSlice';
import loadingReducer from '../slices/loadingSlice';
import storage from 'redux-persist/lib/storage';
import campaignsReducer from '../slices/campaignsSlice';
import notificationReducer from '../slices/notificationSlice';
import viewModeReducer from '../slices/viewModeSlice';
import previewSurveyReducer from '../slices/previewSurveySlice';
import previewLogicPageSurveyReducer from '../slices/previewLogicPageSurveySlice';
import paymentReducer from '../slices/paymentSlice';
import accountReducer from '../slices/accountSlice';
import dataAnalyticsFilterReducer from '../slices/dataAnalyticsFilterSlice';
import dataAnalyticsCompareReducer from '../slices/dataAnalyticsCompareSlice';
import dataAnalyticsDisplayReducer from '../slices/dataAnalyticsDisplaySlice';
import overviewReducer from '../slices/overviewSlice';
import dataCollectReducer from '../slices/dataCollectSlice';
import questionDataFilterReducer from '../slices/questionSummarySlice';
import customerReducer from '../slices/customerSlice';
import uniqLinkReducer from '../slices/uniqLinkSlice';
import themeReducer from '../slices/themeSlice';
import geoLocationReducer from '../slices/geoLocationSlice';

const rootPersistConfig = {
    key: 'root',
    storage: storage,
    // 'theme' chỉ giữ override thủ công (không persist). Màu per-user đi kèm
    // slice 'user' (đã persist) nên reload vẫn giữ đúng màu của user.
    whitelist: ['user'],
};
const rootReducer = combineReducers({
    user: userReducer,
    loading: loadingReducer,
    campaignState: campaignsReducer,
    notification: notificationReducer,
    viewMode: viewModeReducer,
    previewSurvey: previewSurveyReducer,
    previewLogicPageSurvey: previewLogicPageSurveyReducer,
    payment: paymentReducer,
    account: accountReducer,
    dataAnalyticsFilter: dataAnalyticsFilterReducer,
    dataAnalyticsCompare: dataAnalyticsCompareReducer,
    dataAnalyticsDisplay: dataAnalyticsDisplayReducer,
    overview: overviewReducer,
    dataCollect: dataCollectReducer,
    questionDataFilter: questionDataFilterReducer,
    customer: customerReducer,
    uniqLink: uniqLinkReducer,
    theme: themeReducer,
    geoLocation: geoLocationReducer,
});
const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        }),
});

const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export { store, persistor };
